import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=4ddb22cc&scoped=true"
import script from "./Dashboard.js?vue&type=script&lang=js&external"
export * from "./Dashboard.js?vue&type=script&lang=js&external"
import style0 from "./Dashboard.scss?vue&type=style&index=0&id=4ddb22cc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddb22cc",
  null
  
)

export default component.exports